import propTypes from '../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../node_modules/classnames/index.js';
import { styled, useThemeProps } from '@mui/material';
import ActionBarItem from './ActionBarItem.js';
import { ActionBarVerticalAlign } from './constants.js';
import { getActionBarFlexAlign } from './utils.js';
import { createComponentSlot } from '../../modules/styling/theme.js';

var componentRoot = createComponentSlot({
  name: "CinActionBar",
  slot: "Root",
  skipForwardProps: ["spacing", "verticalAlign", "wrap"]
});

var ActionBarBase = function ActionBarBase(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(componentRoot.className, className)
  }, children);
};

ActionBarBase.propTypes = {
  children: propTypes.node,
  verticalAlign: propTypes.any,
  spacing: propTypes.oneOfType([propTypes.number, propTypes.string]),
  verticalSpacing: propTypes.oneOfType([propTypes.number, propTypes.string]),
  wrap: propTypes.bool,
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any
};
var ActionBarRoot = styled(ActionBarBase, componentRoot.styledOptions)(function (_ref2) {
  var _ref2$verticalAlign = _ref2.verticalAlign,
      verticalAlign = _ref2$verticalAlign === void 0 ? ActionBarVerticalAlign.Top : _ref2$verticalAlign,
      verticalSpacing = _ref2.verticalSpacing,
      _ref2$spacing = _ref2.spacing,
      spacing = _ref2$spacing === void 0 ? 0 : _ref2$spacing,
      _ref2$wrap = _ref2.wrap,
      wrap = _ref2$wrap === void 0 ? false : _ref2$wrap,
      theme = _ref2.theme;
  var margin = typeof spacing === "number" ? theme === null || theme === void 0 ? void 0 : theme.spacing(spacing) : spacing;
  var topMargin = typeof verticalSpacing === "number" ? theme === null || theme === void 0 ? void 0 : theme.spacing(verticalSpacing) : verticalSpacing !== null && verticalSpacing !== void 0 ? verticalSpacing : margin;
  return {
    display: "flex",
    flexDirection: "row",
    flexWrap: wrap ? "wrap" : undefined,
    alignItems: getActionBarFlexAlign(verticalAlign),
    marginLeft: "calc(".concat(margin, " * -1)"),
    marginTop: "calc(".concat(topMargin, " * -1)"),
    ".CinActionBarItem-root": {
      marginLeft: margin,
      marginTop: topMargin
    }
  };
});
/**
 * A container for arranging a horizontal group of actions
 */

var ActionBar = function ActionBar(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(ActionBarRoot, rootProps);
}; // bundle related sub-components

/** A container for a single action */


ActionBar.Item = ActionBarItem;
var ActionBar$1 = ActionBar;

export { ActionBar$1 as default };
